export interface RegistrationModelSerialResult {
  status: any;
}
